import styled from '@emotion/styled';

export const BoxInputContainer = styled.div`
	display: flex;
	align-items: center;
	position: relative;

	> .button {
		position: absolute;
		z-index: 1;
		right: 0.5rem;

		body[dir='rtl'] & {
			right: unset;
			left: 0.5rem;
		}
	}

	.boxEditorInput {
		padding-right: 6rem;

		body[dir='rtl'] & {
			padding-right: 1.2rem;
			padding-left: 6rem;
		}
	}

	> div {
		width: 100%;
	}
`;
